/** Header a public patient read carries its PIN Pass in (GET has no body). */
export const PIN_PASS_HEADER = 'X-Pin-Pass';

/** `error` the API answers with when a PIN Pass is missing, wrong or expired. */
export const PIN_REQUIRED_ERROR = 'PIN_REQUIRED';

const FORBIDDEN = 403;

/**
 * Whether a rejected API call is the PIN gate refusing: the API layer rejects
 * with a result carrying the HTTP status as `code` and the axios error as
 * `cause`, whose response body names the `error`.
 */
export function isPinRequiredFailure(failure: unknown): boolean {
  if (typeof failure !== 'object' || failure === null) return false;
  if (!('code' in failure) || failure.code !== FORBIDDEN) return false;
  const cause: unknown = 'cause' in failure ? failure.cause : null;
  if (typeof cause !== 'object' || cause === null || !('response' in cause)) {
    return false;
  }
  const response: unknown = cause.response;
  if (typeof response !== 'object' || response === null) return false;
  const data: unknown = 'data' in response ? response.data : null;
  return (
    typeof data === 'object' &&
    data !== null &&
    'error' in data &&
    data.error === PIN_REQUIRED_ERROR
  );
}
